import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Facebook, Instagram, Phone } from "lucide-react";
import { LOGO_URL, NAV_LINKS, COMPANY } from "../mock";

const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const isActive = (path) =>
    path === "/" ? location.pathname === "/" : location.pathname.startsWith(path);

  return (
    <header className="sticky top-0 z-50">
      {/* Top bar */}
      <div className="gpm-bg-green-dark text-cream hidden md:block">
        <div className="max-w-7xl mx-auto px-6 flex justify-between items-center h-9 text-xs tracking-wide">
          <a href={`tel:${COMPANY.phone}`} className="flex items-center gap-2 gpm-text-cream hover:gpm-text-gold transition-colors">
            <Phone size={13} /> {COMPANY.phone}
          </a>
          <div className="flex items-center gap-4">
            <a href={COMPANY.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="gpm-text-cream hover:gpm-text-gold transition-colors"><Facebook size={15} /></a>
            <a href={COMPANY.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="gpm-text-cream hover:gpm-text-gold transition-colors"><Instagram size={15} /></a>
          </div>
        </div>
      </div>

      {/* Main nav */}
      <div
        className={`gpm-bg-green transition-shadow duration-300 ${scrolled ? "shadow-xl" : ""}`}
      >
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3">
            <img src={LOGO_URL} alt="GPM Classics" className="h-14 w-14 object-contain rounded-full" />
            <div className="leading-none">
              <div className="font-serif-display text-2xl font-bold gpm-text-cream tracking-wide">GPM</div>
              <div className="text-[10px] tracking-[0.35em] gpm-text-gold font-medium">CLASSICS</div>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-7">
            {NAV_LINKS.map((l) => (
              <Link
                key={l.path}
                to={l.path}
                className={`text-[13px] font-medium tracking-wide uppercase transition-colors relative pb-1 ${
                  isActive(l.path) ? "gpm-text-gold" : "gpm-text-cream hover:gpm-text-gold"
                }`}
              >
                {l.label}
                {isActive(l.path) && (
                  <span className="absolute left-0 -bottom-0.5 w-full h-0.5" style={{ background: "var(--gpm-gold)" }} />
                )}
              </Link>
            ))}
          </nav>

          <button className="lg:hidden gpm-text-cream" onClick={() => setOpen(!open)} aria-label="Menu">
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>

        {/* Mobile menu */}
        {open && (
          <div className="lg:hidden gpm-bg-green-dark border-t border-white/10">
            <nav className="flex flex-col px-6 py-3">
              {NAV_LINKS.map((l) => (
                <Link
                  key={l.path}
                  to={l.path}
                  className={`py-3 text-sm uppercase tracking-wide border-b border-white/10 ${
                    isActive(l.path) ? "gpm-text-gold" : "gpm-text-cream"
                  }`}
                >
                  {l.label}
                </Link>
              ))}
            </nav>
          </div>
        )}
      </div>
      <div style={{ height: 3, background: "var(--gpm-gold)" }} />
    </header>
  );
};

export default Header;
